<template>
  <div class="container">
    <headerBox :current="0"></headerBox>
    <bannerBox></bannerBox>
    <div class="common_content">
      <div v-if="showNotice" class="notice_content">
        <noticeBar :content="noticeContent" :noticeId="noticeId"></noticeBar>
        <span class="iconfont icon-close" @click="showNotice = false"></span>
      </div>
      <box1 :style="{ 'margin-top': showNotice ? '' : '50px' }"></box1>
      <div
        :style="{
          backgroundImage: 'url(' + $previewImg + fgImgList.imgUrl + ')',
        }"
        class="banner_bg margin_top_50"
        @click="goImgUrl"
      >
        <!--        <img :src="$previewImg + fgImgList.imgUrl" />-->
      </div>
      <box2 class="margin_top_50"></box2>
      <boxD class="margin_top"></boxD>
      <box3></box3>
      <!-- <box5 class="margin_top"></box5> -->
    </div>
    <box6></box6>
    <bayWindow></bayWindow>
    <!-- <bayWindow2></bayWindow2> -->
    <footerBox></footerBox>
    <Back-top :bottom="120" :height="100">
      <div class="iconfont icon-shangjiantou"></div>
    </Back-top>
  </div>
</template>

<script>
import headerBox from "@/components/header.vue";
import footerBox from "@/components/footer.vue";
import bannerBox from "@/components/banner.vue";
import leftMenu from "@/components/left_menu.vue";
import noticeBar from "@/components/notice.vue";
import bayWindow from "@/components/bay_window.vue";
import bayWindow2 from "@/components/bay_window2.vue";
import box1 from "./components/box1.vue";
import box2 from "./components/box2.vue";
import box3 from "./components/box3.vue";
import boxD from "./components/box_d.vue";
import box5 from "./components/box5.vue";
import box6 from "./components/box6.vue";
import { getArticleDes, getPcList } from "@/api/home/index";
import { ensureHttpsProtocol } from "@/utils/util";
export default {
  name: "home",
  components: {
    headerBox,
    footerBox,
    bannerBox,
    leftMenu,
    noticeBar,
    box1,
    box2,
    box3,
    boxD,
    box5,
    box6,
    bayWindow,
    bayWindow2,
  },
  data() {
    return {
      noticeContent: "",
      showNotice: true,
      noticeId: "",
      fgImgList: [],
    };
  },
  mounted() {
    this.getArticleDes();
    this.getFgData();
  },
  methods: {
    ensureHttpsProtocol,
    /* ====================数据请求部分========================== */
    getArticleDes() {
      getArticleDes({
        catid: 10,
        pageNo: 1,
        pageSize: 1,
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          let newList = res.result.records[0];
          // let arr = [];
          // newList.map(v=>{
          // 	arr.push(v.title)
          // })
          // console.log(newList)
          this.noticeContent = newList.title;
          this.noticeId = newList.id.toString();
        }
      });
    },
    /* ====================页面交互部分========================== */
    goImgUrl() {
      console.log(
        "goImgUrl",
        this.fgImgList.pdfUrl,
        this.ensureHttpsProtocol(this.fgImgList.pdfUrl),
      );
      if (!this.fgImgList.pdfUrl) {
        return;
      }
      // 图片跳转
      const newWindow = window.open("", "_blank");
      setTimeout(() => {
        newWindow.location.href = this.ensureHttpsProtocol(
          this.fgImgList.pdfUrl,
        );
      }, 100);
    },
    getFgData() {
      // 获取分隔图片
      getPcList({
        catid: "220",
        indexshow: "1",
      }).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.fgImgList = res.result[0];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.notice_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .icon-close {
    font-size: 20px;
    cursor: pointer;
    padding-left: 20px;
  }
  .icon-close:hover {
    color: #6d8be7;
  }
}
.banner_bg {
  width: 100%;
  height: 120px;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: all 0.22s ease-in;
  -webkit-transition: all 0.22s ease-in;
  -moz-transition: all 0.22s ease-in;
  -o-transition: all 0.22s ease-in;
  img {
    width: 100%;
    height: 100%;
  }
}
.banner_bg:hover {
  transform: scale(1.02);
}
/* 手机 */
@media only screen and (max-width: 800px) {
  .icon-close {
    padding-left: 15px;
  }
}
</style>
